import type React from "react";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { DefaultLayout } from "~/components/Layout";
import { SimpleResult } from "~/components/SimpleResult";
import { config } from "~/config";
import { useRegistrationReturnTo } from "~/store";

export const VerifyComplete: React.FC = () => {
	const [
		registrationReturnTo,
		_setRegistrationReturnTo, // eslint-disable-line  @typescript-eslint/no-unused-vars
		removeRegistrationReturnTo,
	] = useRegistrationReturnTo();

	let actionLink = <a href={config.tierivPortalUrl}>Go to TIER IV Portal</a>;

	if (registrationReturnTo && registrationReturnTo.expiresAt > Date.now()) {
		const onClick = () => {
			removeRegistrationReturnTo();
			window.location.href = registrationReturnTo.returnTo;
		};
		actionLink = (
			<button type="button" className="t4-link" onClick={onClick}>
				Continue
			</button>
		);
		setTimeout(onClick, 5000);
	} else {
		removeRegistrationReturnTo();
		setTimeout(() => {
			window.location.href = config.tierivPortalUrl;
		}, 5000);
	}

	return (
		<>
			<title>Verify | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<ContentContainer>
						<h1 className="mt-10 text-center font-normal">
							EMAIL VERIFICATION
						</h1>
						<SimpleResult type="success">
							Your email was verified successfully!
						</SimpleResult>
						<p className="text-center">{actionLink}</p>
					</ContentContainer>
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};
